module.exports = __webpack_public_path__ + "static/media/washington-dc-80.372b7a6e.jpg";